import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import InputAdornment from '@mui/material/InputAdornment';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import {Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
// import DateTimePicker from '@mui/lab/DateTimePicker';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import {getVisibility} from '../commonfun/common';
import AgentSelect from '../agents/AgentSelect';
import TagsOptions from '../components/TagsNoOption';
//import moment from 'moment';
import axios from 'axios';
///import Autocomplete from './Autocomplete';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  
  const childRefUser = React.useRef();
  
  const [accessType, setAccessType] = React.useState(1);
  const [accessWithType, setAccessWithType] = React.useState("");
  const [accessWithNames, setAccessWithNames] = React.useState("");
  const [accessWithIds, setAccessWithIds] = React.useState("");

  const [accountName, setAccountName] = React.useState("");
  const [category, setCategory] = React.useState("noselect");
  const [company, setCompany] = React.useState("");
  const [website, setWebsite] = React.useState("");

  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [pinCode, setPinCode] = React.useState("");
  const [country, setCountry] = React.useState("");

  const [gstNumber, setGstNumber] = React.useState("");
  const [panNumber, setPanNumber] = React.useState("");
  const [aadhaarNumber, setAadhaarNumber] = React.useState(""); 
  const [cin, setCin] = React.useState("");
  const [consigneeCode, setConsigneeCode] = React.useState(""); 
  const [products, setProducts] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [rank, setRank] = React.useState("");

  const [tags, setTags] = React.useState([]);
  const [purchasePotential, setPurchasePotential] = React.useState(0);
  const [creditDays, setCreditDays] = React.useState(0);

  const [companyType, setCompanyType] = React.useState("");
  const [registrationYear, setRegistrationYear] = React.useState("");
  const [turnover, setTurnover] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);
  const [ownerAlias, setOwnerAlias] = React.useState("");

  const [categoryList, setCategoryList] = React.useState([]);
  
  //  const [accountAccountAutocomplete, setAccountAutocomplete] = React.useState({});

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {    
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    if(props.dataObj && props.dataObj.autoId){
      setAccountName(props.dataObj.accountName);
      setCategory(props.dataObj.accountCategory);
      setCompany(props.dataObj.company);
      setAddress(props.dataObj.address);
      setCity(props.dataObj.city);
      setState(props.dataObj.state);
      setPinCode(props.dataObj.zipCode);
      setCountry(props.dataObj.country);
      setWebsite(props.dataObj.website);
      setGstNumber(props.dataObj.gstNumber);
      setPanNumber(props.dataObj.panNumber);
      setAadhaarNumber(props.dataObj.aadhaarNumber);
      setCin(props.dataObj.cin); 
      setConsigneeCode(props.dataObj.consigneeCode);
      setProducts(props.dataObj.products);
      setIndustry(props.dataObj.industry);
      setRank(props.dataObj.rank);
      setCompanyType(props.dataObj.companyType);
      setRegistrationYear(props.dataObj.registrationYear);
      setTurnover(props.dataObj.turnover);
      setOwnerId(props.dataObj.ownerId);
      setOwnerAlias(props.dataObj.ownerAlias);
      setAccessType(props.dataObj.accessType);
      setAccessWithType(props.dataObj.accessWithType);
      setAccessWithNames(props.dataObj.accessWithNames);
      setAccessWithIds(props.dataObj.accessWithIds);
      
      setPurchasePotential(props.dataObj.purchasePotential);
      setCreditDays(props.dataObj.creditDays);
      if(props.dataObj.tags){
        setTags(props.dataObj.tags.split(','));
      }
      
    }else{
      setAccountName("");
      setCategory("noselect");
      setCompany("");
      setAddress("");
      setCity("");
      setState("");
      setPinCode("");
      setCountry("");
      setWebsite("");
      setGstNumber("");
      setPanNumber("");
      setAadhaarNumber("");
      setCin("");
      setConsigneeCode("");
      setProducts("");
      setIndustry("");
      setRank("");
      setCompanyType("");
      setRegistrationYear("");
      setTurnover("");
      setOwnerAlias(props.userObj.fullName);
      setOwnerId(props.userObj.userId);
      setAccessWithType("");
      setAccessWithNames("");
      setAccessWithIds("");
      setCreditDays(0);
      setPurchasePotential(0);
      setTags([]);

      if(open){
        setAccessType(getVisibility(props.userObj.visibilityJson,'Accounts'));
      }

    }

    if(open){
      getApiDataCategory();
    }

	}, [props.dataObj,open]);
  
  async function getApiDataCategory(){ 
      let apiUrl=API_URL+'/crm-account-category-cache';
      let axiosHeader = {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
      };
      const config = {
        method: 'get',
        url: apiUrl,
        headers: axiosHeader
      }
      await axios(config)
        .then(response => {
        if(response && response.data && response.data.responseTxt==="success"){  
          setCategoryList(response.data.list);
        }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');
        }
      }).catch((error) => {
          setSeverityAlert("error");
          setShowAlert(true);
          setAlertMessage(""+error);			
          return false;
        })	
  }


	function saveData(){
    if(!accountName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter account name");			
      return false;
    }

		if(accountName){ 

			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      if(accountName){
        data.append('accountName', accountName);
      }
      if(category && category!=='noselect'){
        data.append('accountCategory', category);
      }
      if(company){
        data.append('company', company);
      }
      if(website){
        data.append('website', website);
      }
      if(address){
        data.append('address', address);
      }
      if(city){
        data.append('city', city);
      }
      if(state){
        data.append('state', state);
      }
      if(pinCode){
        data.append('zipCode', pinCode);
      }
      if(country){
        data.append('country', country);
      }
      if(gstNumber){
        data.append('gstNumber', gstNumber);
      }
      if(panNumber){
        data.append('panNumber', panNumber);
      }
      if(aadhaarNumber){
        data.append('aadhaarNumber', aadhaarNumber);
      }
      if(cin){
        data.append('cin', cin);
      }
      if(consigneeCode){
        data.append('consigneeCode', consigneeCode);
      }
      if(products){
        data.append('products', products);
      }
      if(companyType){
        data.append('companyType', companyType);
      }      
      if(registrationYear){
        data.append('registrationYear', registrationYear);
      }      
      if(turnover){
        data.append('turnover', turnover);
      }      
      if(industry){
        data.append('industry', industry);
      }      
      if(rank){
        data.append('rank', rank);
      }
      if(purchasePotential){
        data.append('purchasePotential', purchasePotential);
      }
      if(creditDays){
        data.append('creditDays', creditDays);
      }

      if(tags && tags.length>0){
        data.append('tags', tags.join(','));
      }else{
        data.append('tags', '');
      }

      if(ownerId && ownerId>0){
        data.append('ownerId', ownerId);
        data.append('ownerAlias', ownerAlias);
      }

      data.append('accessType', accessType);
      data.append('accessWithType', accessWithType);
      data.append('accessWithNames', accessWithNames);
      data.append('accessWithIds', accessWithIds);

      let apiURL='/crm-create-accounts';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-accounts';
      }
      setSaveLoading(true);       
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);        
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt); mobileExists
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Account detail has been saved.");
          props.updatedList(response.data.list);	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Account name is already created");			
					return false;  

				}else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Contact detail could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  function selectUser(){
    childRefUser.current.handleClickOpen();
  }
  function userDetail(obj) {
    setOwnerId(obj.autoId);
    setOwnerAlias(obj.fullName);    
  }

  function selectedTags(arr) {
    setTags(arr);
  }

  // const setAutoCompleteDataDetail = (obj,accName) => {
  //   if(obj){
  //     setAccountId(obj.autoId);
  //     setAccountName(obj.title);
  //   }else if(accName && accName.length>0){
  //     setAccountName(accName);
  //     setAccountId("");
  //   }    
  // }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >
                  <div className="btmbdrgry"><h4>Edit Account</h4></div>

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>                          
                          <Grid item md={6} xs={12} >
                              <TextField label="Unique Account Name" onChange={event => setAccountName(event.target.value)} value={accountName} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                            <FormControl fullWidth size='small' >
                                <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={category}
                                  label="Category"
                                  onChange={event => setCategory(event.target.value)}
                                >
                                  <MenuItem value={'noselect'}>Select Category</MenuItem>
                                  {categoryList?categoryList.map((myRow,mykey)=>(
                                    <MenuItem key={'ct'+mykey} value={myRow.category}>{myRow.category}</MenuItem>
                                  )):null}
                                </Select>
                              </FormControl>
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Company" onChange={event => setCompany(event.target.value)} value={company} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Website" onChange={event => setWebsite(event.target.value)} value={website} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Address" onChange={event => setAddress(event.target.value)} value={address} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="City" onChange={event => setCity(event.target.value)} value={city} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="State" onChange={event => setState(event.target.value)} value={state} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Pin Code" onChange={event => setPinCode(event.target.value)} value={pinCode} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Country" onChange={event => setCountry(event.target.value)} value={country} fullWidth variant="outlined" size='small' />
                          </Grid>

                          <Grid item md={6} xs={12} >
                            <TextField label="GST Number" onChange={event => setGstNumber(event.target.value)} value={gstNumber} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                            <TextField label="PAN Number" onChange={event => setPanNumber(event.target.value)} value={panNumber} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                            <TextField label="Aadhaar Number" onChange={event => setAadhaarNumber(event.target.value)} value={aadhaarNumber} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                            <TextField label="Corporate Identification Number (CIN)" onChange={event => setCin(event.target.value)} value={cin} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                            <TextField label="Consignee Code" onChange={event => setConsigneeCode(event.target.value)} value={consigneeCode} fullWidth variant="outlined" size='small' />
                          </Grid>

                          <Grid item md={6} xs={12} >
                                  <FormControl fullWidth size='small' >
                                      <InputLabel id="demo-simple-select-label">Company Type</InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={companyType}
                                        label="Company Type"
                                        onChange={event => setCompanyType(event.target.value)}
                                      >
                                        <MenuItem value={''}>Not Selected</MenuItem>
                                        <MenuItem value={'Sole Proprietorship'}>Sole Proprietorship</MenuItem>
                                        <MenuItem value={'One Person Company'}>One Person Company</MenuItem>
                                        <MenuItem value={'Partnerships Company'}>Partnerships Company</MenuItem>
                                        <MenuItem value={'Private Limited Company'}>Private Limited Company</MenuItem>
                                        <MenuItem value={'Public Limited Company'}>Public Limited Company</MenuItem>
                                      </Select>
                                    </FormControl>
                            </Grid>
                            <Grid item md={6} xs={12} >
                              <TextField label="Year of Registeration" onChange={event => setRegistrationYear(event.target.value)} value={registrationYear} fullWidth variant="outlined" size='small' />
                            </Grid>
                            <Grid item md={6} xs={12} >
                              <TextField label="Sales Turnover" onChange={event => setTurnover(event.target.value)} value={turnover} fullWidth variant="outlined" size='small' />
                            </Grid>
                            <Grid item md={6} xs={12} >
                              <TextField label="Products & Services Sell" onChange={event => setProducts(event.target.value)} value={products} fullWidth variant="outlined" size='small' />
                            </Grid>
                            <Grid item md={6} xs={12} >
                              <TextField label="Industry" onChange={event => setIndustry(event.target.value)} value={industry} fullWidth variant="outlined" size='small' />
                            </Grid>
                            <Grid item md={6} xs={12} >
                              <TextField label="Rank" onChange={event => setRank(event.target.value)} value={rank} fullWidth variant="outlined" size='small' />
                            </Grid>
                            <Grid item md={6} xs={12} >
                              <div>  
                                  <TagsOptions defaultValues={tags} selectedTags={selectedTags} options={[{title:'abc'}]} />
                              </div>                            
                            </Grid>
                            <Grid item md={6} xs={12} >
                              <TextField label="Purchase Potential" onChange={event => setPurchasePotential(event.target.value)} value={purchasePotential} fullWidth variant="outlined" size='small' />
                            </Grid>


                          <Grid item md={6} xs={12} >

                          <Grid container spacing={2}>
                                <Grid item md={8} xs={8} >
                                    <TextField
                                      label="Agent"
                                      onChange={event => setOwnerAlias(event.target.value)}
                                      value={ownerAlias}
                                      fullWidth
                                      size='small'
                                      variant="outlined"
                                      disabled                                      
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectUser()}} />
                                          </InputAdornment>
                                        ),
                                        }}
                                  />
                                </Grid>
                                <Grid item md={4} xs={4} >
                                  <FormControl fullWidth size='small'  >
                                    <InputLabel id="demo-simple-select-label">Visibility</InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={accessType}
                                      label="Visibility"
                                      onChange={event => setAccessType(event.target.value)}
                                    >
                                      <MenuItem value={1} >Public</MenuItem>
                                      <MenuItem value={2} >Private</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>      

                          </Grid>

                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {saveLoading?
                            <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#ea1072',color:'#FFF'}}  size="small" variant="contained" >Saving...</LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }
                            
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <AgentSelect userObj={props.userObj} fetchDetail={userDetail} fetch={true} ref={childRefUser} />

    </>
  );

});

export default CustomizedDialogs;